var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        { staticClass: "flex-grow-1" },
        [_c("DrugSearchNew", { ref: "selectedDrug" })],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-default",
          attrs: { type: "button" },
          on: { click: _vm.addNewDrug },
        },
        [_c("i", { staticClass: "icon-fa icon-fa-plus" })]
      ),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(_vm.localSelectedDrugs, function (d, i) {
        return !d.to_delete
          ? _c("div", { staticClass: "flex mb-1 input-group" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", readonly: "" },
                domProps: { value: d.array_value.drug.title },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: d.array_value.rate,
                    expression: "d.array_value.rate",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "number", placeholder: "Коэффициент" },
                domProps: { value: d.array_value.rate },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(d.array_value, "rate", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("div", { staticClass: "input-group-text" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: d.array_value.useAsClientRequest,
                        expression: "d.array_value.useAsClientRequest",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(d.array_value.useAsClientRequest)
                        ? _vm._i(d.array_value.useAsClientRequest, null) > -1
                        : d.array_value.useAsClientRequest,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = d.array_value.useAsClientRequest,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                d.array_value,
                                "useAsClientRequest",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                d.array_value,
                                "useAsClientRequest",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(d.array_value, "useAsClientRequest", $$c)
                        }
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  readonly: "",
                  value: "учитывать при спросе",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.removeDrug(d.array_value.drug.id)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
              ),
            ])
          : _vm._e()
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }